<template>
  <div class="device-sence">
    <el-switch
      v-model="sceneDeviceNameVisibility"
      class="device-name-visibility"
      :active-text="'显示设备名' | translateTo(i18nPath)"
      inactive-color="#128792"
    ></el-switch>
    <vl-map
      :load-tiles-while-animating="true"
      :load-tiles-while-interacting="true"
      data-projection="EPSG:4326"
      :control="[]"
      v-if="mapUrl"
      @click="mapClick"
      ref="vlMap"
    >
      <vl-view
        :zoom.sync="zoom"
        :center.sync="center"
        :max-zoom="maxZoom"
        :min-zoom="minZoom"
      ></vl-view>
      <vl-layer-tile ref="vlTile">
        <vl-source-xyz :url="mapUrl"></vl-source-xyz>
      </vl-layer-tile>
      <vl-layer-vector>
        <template v-for="v in maps">
          <vl-feature
            :key="v.sn"
            :properties="v"
            v-if="v.nodePosition && v.nodePosition.length"
            :id="v.sn"
          >
            <vl-geom-point :coordinates="v.nodePosition"></vl-geom-point>
            <vl-style-box>
              <vl-style-icon
                :src="iconSrc(v.deviceType, v.sn)"
                :anchor="v.anchor"
                :scale="0.2"
              ></vl-style-icon>
              <vl-style-text
                v-if="sceneDeviceNameVisibility"
                :text="v.deviceName"
                text-baseline="bottom"
                :offset-y="-35"
                font="14px sans-serif"
              >
                <template #background>
                  <vl-style-fill color="#00eeff"></vl-style-fill>
                </template>
              </vl-style-text>
            </vl-style-box>
          </vl-feature>
        </template>
      </vl-layer-vector>

      <!-- 报警区域 -->
      <vl-feature v-for="area in areas.alarm" :key="area.id">
        <vl-geom-polygon :coordinates="area.coordinates"></vl-geom-polygon>
        <vl-style-box>
          <vl-style-fill :color="alarmPolygonCfg.fill"></vl-style-fill>
          <vl-style-stroke
            :color="area.sn === activeSN ? 'blue' : 'red'"
            :width="3"
          ></vl-style-stroke>
          <vl-style-text :text="area.deviceName" font="600 15px 'Fira Sans', sans-serif">
            <template #background>
              <vl-style-fill color="#fff"></vl-style-fill>
            </template>
          </vl-style-text>
        </vl-style-box>
      </vl-feature>
      <!-- 正常设备区域 -->
      <vl-feature v-for="area in areas.normal" :key="area.id">
        <vl-geom-polygon :coordinates="area.coordinates"></vl-geom-polygon>
        <vl-style-box>
          <vl-style-stroke
            :color="area.sn === activeSN ? 'blue' : 'red'"
            :width="3"
          ></vl-style-stroke>
          <vl-style-text :text="area.deviceName" font="600 15px 'Fira Sans', sans-serif">
            <template #background>
              <vl-style-fill color="#fff"></vl-style-fill>
            </template>
          </vl-style-text>
        </vl-style-box>
      </vl-feature>
      <vl-overlay
        id="overlay"
        v-if="overlayData.show"
        :position="overlayData.position"
        :offset="overlayData.offset"
        :positioning="overlayData.direction"
      >
        <info-popup v-bind="overlayData" @close="overlayData.show = false"></info-popup>
      </vl-overlay>
    </vl-map>
    <div class="no-sence" v-else>
      <span v-if="dataLoading || loading">{{ '数据加载中...' | translateTo(i18nPath) }}</span>
      <span v-else>{{ '此设备暂无场景地图' | translateTo(i18nPath) }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isEmpty } from 'lodash';

import GhostAnimator from './GhostAnimator';
import InfoPopup from './components/info-popup.vue';

import { queryStationMap } from '@/api/devices';
import { whichDeviceType } from '@/utils/utils';
import { stateImg } from '@/utils/dict';
import ctt from '@/utils/const';

export default {
  components: {
    InfoPopup
  },
  inject: ['getSceneData', 'getActiveDevice'],
  data() {
    return {
      i18nPath: 'monitor.scene',
      zoom: 2.5,
      minZoom: 2.5,
      maxZoom: 5,
      mapUrl: '',
      center: undefined,
      maps: [],
      iconSNMap: {},
      // extent: [-23559726.606170166, 6320424.994844655, 10488383.273178745, 23344479.934519112],
      curChoosePostion: undefined,
      officeName: '',
      overlayData: {
        show: false
      },
      sceneDeviceNameDep: 1, // 作为场景地图 设备名称是否显示依赖，改变可以刷新vm.sceneDeviceNameVisibility 并且改变localstorage
      activeSN: '',
      loading: true,
      $ghostAnimator: null,
      alarmPolygonCfg: {
        fill: 'rgba(255, 0, 0, .8)',
        timer: null
      }
    };
  },
  computed: {
    ...mapState('device', ['monitorMenuActive']),
    ...mapState('socket', ['dataLoading', 'deviceIdMap', 'deviceSNMap']),
    sceneDeviceNameVisibility: {
      get() {
        let visibility = localStorage.getItem('SCENE_DEVICE_NAME_VISIBILITY');
        if (this.sceneDeviceNameDep && visibility !== '0' && !visibility) {
          localStorage.setItem('SCENE_DEVICE_NAME_VISIBILITY', '1');
          visibility = '1';
        }
        return Boolean(+visibility);
      },
      set(v) {
        localStorage.setItem('SCENE_DEVICE_NAME_VISIBILITY', String(+v));
        this.sceneDeviceNameDep++;
      }
    },
    activeDevice() {
      const { id } = this.monitorMenuActive;
      const device = this.deviceIdMap[id];
      return device || {};
    },
    activeMenuSN() {
      return this.activeDevice.sn;
    },
    devices() {
      if (!this.maps || !Array.isArray(this.maps) || !this.maps.length) return [];
      let res = this.maps.filter(e => {
        try {
          if (!e.areaPosition) return false;
          const res = JSON.parse(e.areaPosition);
          return Array.isArray(res);
        } catch (error) {
          return false;
        }
      });
      if (!res.length) return [];
      res = res.map(e => this.deviceSNMap[e.sn]).filter(Boolean);
      return res;
    },
    areas() {
      const list = this.devices;
      const alarm = [];
      const normal = [];
      let temp = null;
      list.forEach(e => {
        temp = {
          id: e.id,
          sn: e.sn,
          deviceName: e.name,
          coordinates: JSON.parse(e.areaCoordinate)
        };
        if (e.state === ctt.POINT_STATE_DANGER || e.state === ctt.POINT_STATE_WARN) {
          alarm.push(temp);
        } else {
          normal.push(temp);
        }
      });
      return {
        alarm,
        normal
      };
    }
  },
  methods: {
    twinkle() {
      const { alarmPolygonCfg } = this;
      if (alarmPolygonCfg.timer) return;
      const fill = opacity => `rgba(255, 0, 0, ${Number(opacity / 100).toFixed(2)})`;
      let cur = 0;
      const low = 20;
      const high = 80;
      const time = 5;
      const pause = 150;
      this.clearTwinkle();
      alarmPolygonCfg.timer = setInterval(() => {
        cur = cur + time >= high ? low : cur + time;
        alarmPolygonCfg.fill = fill(cur);
      }, pause);
    },
    clearTwinkle() {
      const { alarmPolygonCfg } = this;
      if (alarmPolygonCfg.timer) {
        clearInterval(alarmPolygonCfg.timer);
        alarmPolygonCfg.timer = null;
      }
    },
    getSnState(sn) {
      const snInfo = this.deviceSNMap[String(sn)];
      return snInfo && snInfo.state;
    },
    iconSrc(type, sn) {
      const prefix = sn === this.activeSN || sn === this.activeMenuSN ? 'selected' : 'unselected';
      return `static/image/ol/${prefix}/${whichDeviceType(type)}/${
        stateImg[this.getSnState(sn)]
      }.png`;
    },
    mapClick(evt) {
      this.isDeviceFlag(evt)
        .then(res => {
          this.activeSN = res.sn;
          this.showInfoPopup(res, evt.coordinate);
        })
        .catch(() => {
          this.activeSN = '';
          this.hiddenInfoPopup();
        });
    },
    isDeviceFlag(evt) {
      return new Promise((resolve, reject) => {
        const feature = evt.map.forEachFeatureAtPixel(evt.pixel, function (fea, _layer) {
          return fea;
        });
        if (feature) {
          const props = feature.getProperties();
          if (props.pixelType !== 'deviceFlag') return;
          resolve(props);
        } else {
          reject(new Error('not feature'));
        }
      });
    },
    showInfoPopup(props, clickPosition) {
      const deviceInfo = this.deviceSNMap[props.sn];
      if (!deviceInfo) return;
      const state = deviceInfo.state;
      this.overlayData = {
        state,
        show: true,
        officeName: this.officeName,
        sn: props.sn,
        position: clickPosition,
        deviceType: props.deviceType,
        deviceName: props.deviceName,
        direction: 'top-center',
        offset: [0, -25]
      };
    },
    hiddenInfoPopup() {
      this.overlayData = { show: false };
    },
    refreshScene() {
      this.$refs.vlMap.refresh();
    },
    updateSceneInfo(res) {
      if (this.mapUrl.indexOf(res.data.map) === -1) {
        this.center = res.data.centerPosition || undefined;
      }
      this.mapUrl = res.data.map ? `${res.data.map}/{z}-{x}-{y}.png` : '';
      this.curChoosePostion = res.data.nodePosition || undefined;
      if (res.data.devices) {
        this.maps = res.data.devices
          .map(e => {
            this.iconSNMap[e.sn] = e;
            return Object.assign(e, { pixelType: 'deviceFlag', anchor: [0.5, 1] });
          })
          .filter(e => Boolean(this.deviceSNMap[e.sn]));
      }
      this.officeName = res.data.stationName;
      this.$emit('modify-title', this.officeName);
    },
    ceaseLoading() {
      this.loading = false;
    },
    startIconAnimate(nodeType) {
      if (nodeType === 1) return;
      const getVmap = () => this.$refs.vlMap;
      const sn = this.activeDevice.sn;
      if (this.$ghostAnimator) {
        this.$ghostAnimator.clearAnimation();
      } else {
        this.$ghostAnimator = new GhostAnimator({ duration: 1600 });
        this.$watch(
          'sceneDeviceNameVisibility',
          function (n) {
            this.$ghostAnimator.resetOwnStyle(`icon${n ? ',text' : ''}`);
          },
          { immediate: true }
        );
      }
      let timer = null;
      let execAnimation = null;
      const success = () => {
        clearTimeout(timer);
      };
      const fail = () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          execAnimation(getVmap());
          clearTimeout(timer);
        }, 1000);
      };
      execAnimation = vmap => {
        if (!this.loading && vmap && !vmap.featureIds.includes(sn)) return;
        vmap && this.$ghostAnimator.resetMapFeat(vmap.$map, vmap.getFeatureById(sn));
        this.$ghostAnimator.executor().then(success).catch(fail);
      };
      execAnimation(getVmap());
    },
    monitorMenuActiveChange(newVal) {
      if (!isEmpty(newVal)) {
        this.loading = true;
        this.startIconAnimate(newVal.nodeType);
        queryStationMap(newVal)
          .then(res => {
            this.updateSceneInfo(res);
          })
          .finally(() => {
            this.ceaseLoading();
          });
      } else {
        this.$ghostAnimator && this.$ghostAnimator.clearAnimation();
      }
    }
  },
  watch: {
    monitorMenuActive: {
      handler: 'monitorMenuActiveChange',
      immediate: true
    },
    'areas.alarm'(n) {
      if (!n.length) {
        this.clearTwinkle();
        return;
      }
      this.twinkle();
    }
  },
  beforeDestory() {
    this.clearTwinkle();
    this.$ghostAnimator && this.$ghostAnimator.clearAnimation();
  }
};
</script>

<style lang="scss">
.device-sence {
  position: relative;
  height: 100%;
  .no-sence {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $normal-color;
    font-size: 26px;
    font-weight: bold;
    letter-spacing: 3px;
  }
  .custom-overlayer-info {
    width: max-content;
    min-width: 285px;
    position: absolute;
    left: 0;
    right: 0;
    transform: translate(-50%, -100%);
    background: #fff;
    color: #aaa;
    .el-card__header {
      border: 0;
      padding: 8px 20px;
    }
    .el-card__body {
      padding: 8px 20px;
    }
    &__content {
      & > div {
        line-height: 26px;
      }

      .state-text {
        @include state-textstyle;
      }

      .operation {
        overflow: hidden;

        display: flex;
        justify-content: flex-end;

        .el-button--mini,
        .el-button--mini.is-round {
          padding: 7px 0px 0px;
        }
      }
    }
  }
  .device-name-visibility {
    position: absolute;
    right: 10px;
    top: 60px;
    z-index: 2;
  }
}
</style>
